import Atividade from "@pages/Atividade/Atividade";

export default Atividade;
